import { COUNTRY_AND_PROVINCES } from "../types/countryAndProvincesInfoTypes";

export const setCountryAndProvincesInfo = (canadaProvinces: any) => {
  return {
    type: COUNTRY_AND_PROVINCES.COUNTRY_AND_PROVINCES_SET_SELECTED,
    payload: { ...canadaProvinces },
  };
};

export const clearCountryAndProvincesInfo = () => {
  return {
    type: COUNTRY_AND_PROVINCES.COUNTRY_AND_PROVINCES_CLEAR_SELECTED,
  };
};
